<template>
  <!-- Main Wrapper -->
  <div class="main-wrapper">
    <layouts></layouts>
    <sidebar></sidebar>
    <div class="page-wrapper">
      <div class="content">
        <pageheader :title="title" :title1="title1" />
        <!-- /add -->
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-lg-3 col-sm-6 col-12">
                <div class="form-group">
                  <label>Supplier Name</label>
                  <input type="text" v-model="form.vendorname"/>
                </div>
              </div>
              <div class="col-lg-3 col-sm-6 col-12">
                <div class="form-group">
                  <label>Contact Person</label>
                  <input type="text" v-model="form.contactperson"/>
                </div>
              </div>
              <div class="col-lg-3 col-sm-6 col-12">
                <div class="form-group">
                  <label>Address</label>
                  <input type="text" v-model="form.address"/>
                </div>
              </div>
              <div class="col-lg-3 col-sm-6 col-12">
                <div class="form-group">
                  <label>Email</label>
                  <input type="text" v-model="form.email"/>
                </div>
              </div>
              <div class="col-lg-3 col-sm-6 col-12">
                <div class="form-group">
                  <label>Phone</label>
                  <InternationalPhoneInput
                    ref="phoneInput"
                    v-model="form.phone"
                    :submitted="phoneSubmitted"
                  />
                </div>
              </div>
              <div class="col-lg-3 col-sm-6 col-12">
                <div class="form-group">
                  <label>GSTIN</label>
                  <input type="text" v-model="form.gstin" maxlength="15"/>
                </div>
              </div>
              <!-- <div class="col-lg-9 col-12">
                <div class="form-group">
                  <label>Address</label>
                  <input type="text" value="132, My Street, Kingston, New York " />
                </div>
              </div> -->
              <!-- <div class="col-lg-12">
                <div class="form-group">
                  <label>Description</label>
                  <textarea class="form-control">
Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text </textarea
                  >
                </div>
              </div> -->
              <!-- <div class="col-lg-12">
                <div class="form-group">
                  <label> Avatar</label>
                  <div class="image-upload">
                    <input type="file" />
                    <div class="image-uploads">
                      <img src="../../../assets/img/icons/upload.svg" alt="img" />
                      <h4>Drag and drop a file to upload</h4>
                    </div>
                  </div>
                </div>
              </div> -->
              <div class="col-lg-12">
                <a v-on:click="postData()" class="btn btn-submit me-2">Submit</a>
                <router-link to="supplierlist" class="btn btn-cancel">Cancel</router-link>
              </div>
            </div>
          </div>
        </div>
        <!-- /add -->
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import InternationalPhoneInput from "@/components/InternationalPhoneInput.vue";
axios.defaults.baseURL = process.env.VUE_APP_API_URL;
axios.defaults.headers.post['Content-Type'] ='application/json;charset=utf-8';
export default {
  components: { InternationalPhoneInput },
  data() {
    return {
      form: {
        vendorname: '',
        contactperson: '',
        address: '',
        email: '',
        phone: '',
        gstin: '',
      },
      phoneSubmitted: false,
      filter: true,
      id: this.$route.query.id,
      title: "Edit Supplier",
      title1: "Edit",
    };
  },
  methods: {
    postData() {
      if (!this.form.vendorname) {
        Swal.fire("Please enter the Supplier name");
        return;
      }
      this.phoneSubmitted = true;
      if (!this.$refs.phoneInput.validate()) {
        Swal.fire("Please enter a valid phone number");
        return;
      }
      axios
      .put('/v1/vendors/' + this.id, this.form)
      .then(response => {
        Swal.fire("Supplier updated successfully");
        this.$router.push({ path: '/supplierlist' });
      })
      .catch(error => {
        console.log(error)
        Swal.fire(error.response.data.detail);
      });
    },
    async getVendorsById(id) {
      axios
      .get('/v1/vendors/'+id)
      .then(response => {
        this.form = response.data
      })
      .catch(error => {
        console.log(error)
        this.errored = true
      });
    }
  },
  beforeMount() {
    this.id = this.$route.query.id
    this.getVendorsById(this.id);
  },
  name: "editsupplier",
};
</script>
